import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import InputText from 'LuxKit/Typography/InputText'

const LabelText = styled(InputText)`
  display: block;

  & + * {
    margin-block-start: ${rem(4)};
  }
`

const TextInputContainer = styled.label`
  display: block;
`

interface Props extends React.LabelHTMLAttributes<HTMLLabelElement> {
  label?: React.ReactNode
  required?: boolean
  requiredIndicatorEnabled?: boolean
  optionalIndicatorEnabled?: boolean
  /** Keep adjacent interactive content outside the label; requires htmlFor. */
  separateLabel?: boolean
}

const InputLabelWrap = React.forwardRef<HTMLLabelElement, Props>((props, ref) => {
  const {
    label,
    children,
    separateLabel,
    htmlFor,
    required,
    requiredIndicatorEnabled = false,
    optionalIndicatorEnabled = true,
    ...labelProps
  } = props

  const intl = useIntl()

  const optionalLabel = intl.formatMessage({
    id: 'bXDB0A5jgp445ALgR591',
    defaultMessage: '(optional)',
  })

  const showOptional = !required && optionalIndicatorEnabled && !requiredIndicatorEnabled
  const showRequired = required && requiredIndicatorEnabled
  const requiredIndicator = ' *'

  const labelWithOptional = <FormattedMessage
    id="ZzMm8UVJ4Bvw6gNEkVFc"
    defaultMessage="{label} {optionalIndicator}"
    
    values={{
      label,
      optionalIndicator: <InputText as="span" variant="sub-label">{optionalLabel}</InputText>,
    }}
  />

  const labelContent = showOptional ? labelWithOptional : <>{label}{showRequired && <span aria-hidden="true">{requiredIndicator}</span>}</>
  const labelText = separateLabel
    ? <LabelText forwardedAs="label" htmlFor={htmlFor} variant="label">{labelContent}</LabelText>
    : <LabelText variant="label">{labelContent}</LabelText>

  return (
    <TextInputContainer
      {...labelProps}
      as={separateLabel ? 'div' : 'label'}
      htmlFor={separateLabel ? undefined : htmlFor}
      ref={ref}
    >
      {label && labelText}
      {children}
    </TextInputContainer>
  )
})

InputLabelWrap.displayName = 'InputLabelWrap'

export default InputLabelWrap
